import { useI18n } from '../i18n/useI18n';
import { Alert } from './Alert';

/**
 * Shown in every dialog that changes something, and it now says more than it
 * used to — because more of it is true.
 *
 * The change is recorded under the person's name in the control plane's own
 * trail. Where the change reaches the tenancy's cluster, the name travels with
 * it: gdsgate takes a claimed operator on its administrative calls, writes it
 * to a column of its own and prints it on a line of its own, marked as claimed
 * by the caller and **not verified**. That marking is the honest part and the
 * notice keeps it: a tenancy cannot check which person at the provider pressed
 * a button, so it trusts the provider as a whole, and a console that said
 * "verified" would be selling that trust as proof.
 *
 * The other half of the same fact is a refusal, not a footnote: a name gdsgate
 * will not record is turned away at the edge with `operator_not_nameable`, and
 * nothing is changed on either side. That is why this notice is worth reading
 * before the button and not after it.
 *
 * The name arrives as a prop rather than out of a session hook: both consoles
 * use this component and they hold different session types, and neither should
 * be able to reach the other's.
 */
export function AttributionNotice({ actorName }: { actorName: string }) {
  const { t } = useI18n();

  return (
    <Alert tone="info" title={t('attribution.title')}>
      <p>{t('attribution.body', { actor: actorName })}</p>
      {/* The name on the line above is the fact. How far it travels, how it is
          marked at the other end, and what happens to a name gdsgate will not
          take are the same three sentences in every dialog — so they wait here
          rather than standing over every button. */}
    </Alert>
  );
}
